import styled from 'styled-components';

const CalendarDateView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--gray900);
  text-align: center;
  position: relative;
  height: 40px;
  cursor: pointer;
  &:before, &:after {
    content: "";
    position: absolute;
    width: 50%;
    height: calc(100% - 8px);
    top: 4px;
    transition: all 0.2s ease;
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
  > .label {
    content: "";
    position: absolute;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 50%;
    font-size: 0.75em;
    z-index: 1;
    transition: all 0.1s;
  }
  &:hover {
    > .label {
      background-color: var(--blue400);
      color: var(--gray0);
    }
  }
  &.hidden {
    opacity: 0;
  }
  &.disabled {
    color: var(--gray300);
    > .label {
      background-color: transparent;
    }
  }
  &.between {
    &:before {
      background-color: var(--blue200);
    }
    &:after {
      background-color: var(--blue200);
    }
  }
  &.start {
    &:before {
      background-color: transparent!important;
    }
    &:after {
      background-color: var(--blue200);
    }
    > .label {
      background-color: var(--blue500);
      color: var(--gray0);
    }
  }
  &.end {
    &:before {
      background-color: var(--blue200);
    }
    &:after {
      background-color: transparent!important;
    }
    > .label {
      background-color: var(--blue500);
      color: var(--gray0);
    }
  }
`;

export default CalendarDateView;
